import React from 'react';

import { PartnerLogos } from '@hpstellar/core';

import withWindowResize from '../../ui/components/window-resize';

import { getPartnerLogoContent } from '../../utility/setHtml';

import './footer-logo.less';

const FooterLogo = ({ logos, width, breakpoint }) => {
    if (width >= breakpoint) return null;
    return (
        <div className="footerLogo">
            <PartnerLogos className="footer-logo-container" logos={getPartnerLogoContent(logos)} />
        </div>
    );
};

export default withWindowResize(FooterLogo);
